export default __webpack_public_path__ + "static/media/YAS0920.34I-42439_-25422_0.fba6aaa8.jpg";